import React from "react";

const plusIcon = <i class="fa fa-plus" aria-hidden="true" />;
const minusIcon = <i class="fa fa-minus" aria-hidden="true" />;

export const softwareTableItems = [
    {
        customer_id: "OU7W81JT 1",
        software: "AERMOD",
        edition: "Pro Plus",
        version: "v9.9.99",
        released: "April 16, 2019",
        activated: "No",
        maintenance: "Active until Nov. 25, 2019",
    },
    {
        customer_id: "OU7W81JT 2",
        software: "AERMOD",
        edition: "Pro Plus",
        version: "v9.9.99",
        released: "April 16, 2019",
        activated: "No",
        maintenance: "Active until Nov. 25, 2019",
    },
    {
        customer_id: "OU7W81JT 3",
        software: "AERMOD",
        edition: "Pro Plus",
        version: "v9.9.99",
        released: "April 16, 2019",
        activated: "No",
        maintenance: "Active until Nov. 25, 2019",
    },
    {
        customer_id: "OsU7W81JT 4",
        software: "AERMOD",
        edition: "Pro Plus",
        version: "v9.9.99",
        released: "April 16, 2019",
        activated: "No",
        maintenance: "Active until Nov. 25, 2019",
    },
];

export const orderTableItems = [
    {
        id: 3,
        order_id: "OU7W81JT 3",
        order_date: "07-14-2020",
        payment_status: "Paid Online",
        order_status: "Completed",
        order_amount: "$1.00",
    },
    {
        id: 3,
        order_id: "OU7W81JT 3",
        order_date: "07-14-2020",
        payment_status: "Paid Offline",
        order_status: "Incomplete",
        order_amount: "$1.00",
    },
    {
        id: 3,
        order_id: "OU7W81JT 3",
        order_date: "07-14-2020",
        payment_status: "Paid Online",
        order_status: "Incomplete",
        order_amount: "$1.00",
    },
    {
        id: 3,
        order_id: "OU7W81JT 3",
        order_date: "07-14-2020",
        payment_status: "Paid Offline",
        order_status: "Completed",
        order_amount: "$1.00",
    },
];

export const dataTableItems = [
    {
        customer_id: "OU7W81JT 1",
        data: "ADMS Data",
        released: "April 16, 2019",
    },
];

export const orderDataTableItems = [
    {
        order_id: "OU7W81JT 1",
        data: "ADMS Data",
        released: "April 16, 2019",
    },
];

export const jobsTableItems = [
    {
        id: "OsU7W81JT 1",
        project_name: "AAir Dispersion Modeling Test",
        run_time: "12:34:56",
        submitted: "Jun. 12, 2019  2:38PM",
        started: "Jun. 12, 2019  2:38PM",
        status: "Running (85% complete)",
    },
    {
        id: "OsU7W81JT 2",
        project_name: "AAir Dispersion Modeling Test",
        run_time: "12:34:56",
        submitted: "Jun. 12, 2019  2:38PM",
        started: "Jun. 12, 2019  2:38PM",
        status: "Running (85% complete)",
    },
    {
        id: "OsU7W81JT 3",
        project_name: "AAir Dispersion Modeling Test",
        run_time: "12:34:56",
        submitted: "Jun. 12, 2019  2:38PM",
        started: "Jun. 12, 2019  2:38PM",
        status: "Running (85% complete)",
    },
];

export const trainingTableItems = [
    {
        order_id: "1",
        order_date: "Jun. 12, 2020",
        name: "Name",
        issued_to: "Aaron Day 1",
    },
    {
        order_id: "2",
        order_date: "Jun. 12, 2020",
        name: "Name",
        issued_to: "Aaron Day 2",
    },
    {
        order_id: "3",
        order_date: "Jun. 12, 2020",
        name: "Name",
        issued_to: "Aaron Day 3",
    },
];

export const eLearningItems = [
    {
        name: "Jayant",
        detail: "Test",
        length: "Code"
    },
    {
        name: "Jayant",
        detail: "Test",
        length: "Code"
    }
]

export const resultsTableItems = [
    {
        id: "OsU7W81JT 3",
        project_name: "AAir Dispersion Modeling Test",
        run_time: "12:34:56",
        submitted: "Jun. 12, 2019  2:38PM",
        started: "Jun. 12, 2019  2:38PM",
        status: "Completed",
        cost: "$25.00",
    },
    {
        id: "OsU7W81JT 4",
        project_name: "AAir Dispersion Modeling Test",
        run_time: "12:34:56",
        submitted: "Jun. 12, 2019  2:38PM",
        started: "Jun. 12, 2019  2:38PM",
        status: "Completed",
        cost: "$25.00",
    },
    {
        id: "OsU7W81JT 5",
        project_name: "AAir Dispersion Modeling Test",
        run_time: "12:34:56",
        submitted: "Jun. 12, 2019  2:38PM",
        started: "Jun. 12, 2019  2:38PM",
        status: "Completed",
        cost: "$25.00",
    },
];

export const softwareCategories = [
    "Customer ID",
    "Software",
    "Edition",
    "Version",
    "Released",
    "Activated",
    "Maintenance Expiration Date",
];
export const orderCategories = [
    "Order Number",
    "Order Date",
    "Order Amount",
    "Payment Status",
    "Order Status",
];

export const oldOrderHistory = [
    "Order Date",
    "Order Number",
    "Total"
];

export const oldLearningColumns = [
    "Course Name",
    "Length",
];

export const dataDownloadsCategories = ["Order ID", "Data", "Released"];
export const orderDataDownloadsCategories = ["Customer ID", "Data", "Released"];
export const jobCategories = [
    "Id",
    "Project",
    "Run Time",
    "Submitted",
    "Started",
    "Status"
];
export const completedTabNames = [
    "Id",
    "Project",
    "Run Time",
    "Submitted",
    "Started",
    "Completed",
    "Cost",
    "Status",
    "Results"
];
export const trainingCategories = [
    "Order Number",
    "Order Date",
    "Name",
    "Issued To",
];
export const eLearningCategories = [
    "Name",
    "Details",
    "Length",
];
export const webinarCategories = [
    "Name",
    // "Details",
    "Length",
    "Order Number",
    "Start Date"
];
export const resultsCategories = [
    "Id",
    "Project",
    "Run Time",
    "Submitted",
    "Started",
    "Status"
];
export const queuedTabNames = [
    "Id",
    "Project",
    "Run Time",
    "Submitted",
    "Started",
    "Status"
];
